import { IPaymentMethod } from './payment-methods.interface';

export interface IPaymentMethodV2DataRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: IPaymentMethodV2[];
}

export interface IPaymentMethodV2 {
  id_formapago_v2: string;
  codigo: string;
  numero_referencia: string;
  nombre: string; // Nombre de la forma de pago (Cuenta Ahorros, Visa, etc.)

  // Campos clave para la jerarquía de 3 niveles
  tipo_pago: TipoPagoV2Enum; // Nivel 1: DÉBITO/CRÉDITO
  entidad_financiera: string; // Nivel 2: Código de entidad bancaria (FK)

  // Mapeo a FormaPago V1 para compatibilidad
  forma_pago_legacy?: string | null; // Código de la forma de pago V1
  forma_pago_legacy_data?: IPaymentMethod | null; // Datos completos de forma pago V1

  // Aplicabilidad
  aplica_home: boolean;
  aplica_pyme: boolean;
  aplica_corporativo: boolean;

  // Auditoría
  estado: boolean;
  fecha_creacion?: string;
  fecha_modificacion?: string;
}

// Tipo de pago para estructura de 3 niveles
export enum TipoPagoV2Enum {
  DEBITO = 'DÉBITO',
  CREDITO = 'CRÉDITO',
  RECAUDACION = 'RECAUDACIÓN',
  TRANSFERENCIA = 'TRANSFERENCIA',
}

export const TIPO_PAGO_V2_OPTIONS = [
  TipoPagoV2Enum.DEBITO,
  TipoPagoV2Enum.CREDITO,
  TipoPagoV2Enum.RECAUDACION,
  TipoPagoV2Enum.TRANSFERENCIA,
];
